export function hasOwnPropertyGuard<T extends object>(obj: T, property: any): property is keyof T {
    return obj.hasOwnProperty(property);
}
